// extracted by mini-css-extract-plugin
module.exports = {"TableData":"TableData_TableData__2DLTI"};